import React from "react";
import { useOutletContext } from "react-router-dom";
import MatchesGrid from "../components/MatchesGrid";

// "AutoPilot Jobs" tab — the Matches-for-you grid. `onApply` (opens the tailoring modal) and
// `appliedOverrides` (live status pills for jobs just applied to) come from the Autopilot hub via
// Outlet context, so the modal and real-time updates keep working when switching tabs.
export default function AutopilotJobs() {
  const ctx = useOutletContext() || {};
  return <MatchesGrid onApply={ctx.onApply} onNewLink={ctx.onNewLink} appliedOverrides={ctx.appliedOverrides || {}} />;
}
